import { Component, Input } from '@angular/core';
import { EoBaseViewComponent } from '../eo-base-view/eo-base-view.component';
import { IViewComponent } from '../eo-base-view/i-view-component';
import { formatDate } from '@angular/common';
import { EoViewComponentTypeEnum } from '../eo-base-view/eo-view-component-type-enum';

@Component({
  selector: 'eo-date',
  templateUrl: './eo-date.component.html',
  styleUrl: './eo-date.component.scss',
})
export class EoDateComponent
  extends EoBaseViewComponent
  implements IViewComponent
{
  @Input() dateFormat?: string;

  getFormattedValue(): string {
    // Ensure this.value is of type Date
    const dateValue: Date | undefined =
      typeof this.value === 'string' ? new Date(this.value) : this.value;

    if (!dateValue) return '-';

    const format = this.dateFormat ?? 'dd/MM/yyyy';

    return formatDate(dateValue, format, 'en-US');
  }

  getViewComponentType(): EoViewComponentTypeEnum{
    return EoViewComponentTypeEnum.DATE;
  }
}
